export const fileToUint8Array = (file: File): Promise<Uint8Array> => {
 return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const result = new Uint8Array(fileReader.result as ArrayBuffer);
      resolve(result);
    };
    fileReader.readAsArrayBuffer(file);
  });
}

export const base64ToJPG = (base64Image: string): File => {
  const arr = base64Image.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], 'filename.jpg', { type: mime });
}

export const blobToImage = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
}

export const base64ToBlob = (base64: string): Blob => {
  // Convert base64 to blob and create object URL
  const base64Data = base64.split(',')[1] || base64;
  const mimeType = base64.match(/data:([^;]+);/)?.[1] || 'application/octet-stream';
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });
  return blob;
}

export const base64ImageToFile = (base64: string): File => {
  // Detect format from base64 magic bytes (no data URI prefix needed)
  // JPEG magic bytes: FF D8 FF → base64 starts with '/9j/'
  // PNG magic bytes:  89 50 4E → base64 starts with 'iVBOR'
  const isPng = base64.startsWith('iVBOR');
  const mimeType = isPng ? 'image/png' : 'image/jpeg';
  const extension = isPng ? 'png' : 'jpg';
  const name = `document.${extension}`;

  const bstr = atob(base64);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], name, { type: mimeType });
};